import UFunction from "@repo/utils/UFunction";

import Rpc from "../utils/Rpc";

import { canadaFrontendServices } from "./services";

const stubs = import.meta.env.DEV
  ? UFunction.memo(() =>
      import("../canada/frontend/stubs").then((res) => res.default)
    )
  : undefined;

const serviceCache: Rpc.Cache = {};

const transport = Rpc.createTransport({
  serviceCache,
  basePath: "/frontend",
});

const canadaFrontendRpc = Rpc.createServicesClient(canadaFrontendServices, {
  serviceCache,
  transport,
  stubs,
});

export default canadaFrontendRpc;
